export default {
  orgCCList: {
    data: [],
  },
};
